import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';

import { Theme } from '@app/theme';
import { SingleValueConfig } from '@app/api';
import { Input, Toggle } from '@app/form';

import { FoldableOpenMore } from 'components';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    marginBottom: theme.marginBase * 4,
  },
  toggle: {
    marginBottom: theme.marginBase,
    marginTop: 0,
  },
  content: {
    marginTop: theme.marginBase,
    backgroundColor: theme.colors.white,
    padding: theme.marginBase,
    borderRadius: theme.borderRadius.std,
  },
}));

interface Props {
  label: string;
  name: string;
  value: SingleValueConfig;
  onChange: (name: string, value: SingleValueConfig) => any;
  withMissingValue?: boolean;
}

export const SingleValueScoringFields = ({
  label,
  name,
  value,
  onChange,
  withMissingValue,
}: Props) => {
  const classes = useStyles();

  const onEnabledChange = useCallback(
    (checked: boolean) => {
      onChange(name, { ...value, enabled: checked });
    },
    [onChange, name, value],
  );

  const onInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(name, { ...value, [e.target.name]: Number(e.target.value) });
    },
    [onChange, name, value],
  );

  return (
    <div className={classes.container}>
      <Toggle
        label={label}
        checked={value.enabled}
        onChange={onEnabledChange}
        containerClass={classes.toggle}
      />
      <FoldableOpenMore label="Avancé">
        <div className={classes.content}>
          <Input
            label="Poid"
            name="weight"
            value={value.weight}
            onChange={onInputChange}
            small
            noMargin
            type="number"
            step={0.1}
            min={0}
          />

          {!!withMissingValue && (
            <Input
              label="Valeur si vide"
              name="missingValue"
              value={value.missingValue}
              onChange={onInputChange}
              small
              noMargin
              type="number"
              step={0.1}
              min={0}
              max={1}
            />
          )}
        </div>
      </FoldableOpenMore>
    </div>
  );
};
